import password_rejected from './password-rejected.js';
const error = {
    no_recovery_contact: 'This account has no email or phone number on file for password recovery. Please contact your institution.',
    general_required: `{{types, list(type: disjunction;)}} je povinné`,
    general_invalid: `{{types, list(type: disjunction;)}} je neplatné`,
    invalid_min_max_input: 'Hodnota musí být mezi {{minValue}} a {{maxValue}} znaky',
    invalid_min_max_length: 'Délka hodnoty musí být mezi {{minLength}} a {{maxLength}} znaky',
    username_required: 'Uživatelské jméno je povinné',
    password_required: 'Heslo je povinné',
    username_exists: 'Uživatelské jméno již existuje',
    username_should_not_start_with_number: 'Uživatelské jméno nesmí začínat číslem',
    username_invalid_charset: 'Uživatelské jméno může obsahovat pouze písmena, čísla a podtržítka',
    username_too_short: 'Uživatelské jméno musí být alespoň {{min}} znaků dlouhé.',
    username_too_long: 'Uživatelské jméno musí být nejvýše {{max}} znaků dlouhé.',
    username_uppercase_not_allowed: 'Velká písmena nejsou povolena v uživatelských jménech.',
    username_lowercase_not_allowed: 'Malá písmena nejsou povolena v uživatelských jménech.',
    username_numbers_not_allowed: 'Čísla nejsou povolena v uživatelských jménech.',
    username_underscore_not_allowed: 'Podtržítka nejsou povolena v uživatelských jménech.',
    invalid_email: 'E-mailová adresa je neplatná',
    invalid_phone: 'Telefonní číslo je neplatné',
    passwords_do_not_match: 'Hesla se neshodují. Zkus to prosím znovu.',
    invalid_passcode: 'Ověřovací kód je neplatný.',
    device_code_required: 'Kód je povinný.',
    invalid_device_code: 'Kód zařízení je neplatný.',
    device_flow_aborted: 'Požadavek na přihlášení byl přerušen.',
    invalid_connector_auth: 'Ověření je neplatné',
    invalid_connector_request: 'Zadané údaje jsou neplatné',
    unknown: 'Neznámá chyba.',
    invalid_session: 'Relace nebyla nalezena. Prosím vrať se zpět a přihlas se znovu.',
    timeout: 'Vypršel časový limit požadavku.',
    password_rejected,
    sso_not_enabled: 'Single Sign-On není povolen pro tento e-mailový účet.',
    invalid_link: 'Neplatný odkaz',
    invalid_link_description: 'Tvůj jednorázový kód mohl vypršet nebo již není platný.',
    captcha_verification_failed: 'Ověření, že nejsi robot, se nezdařilo.',
    terms_acceptance_required: 'Je nutné souhlasit s podmínkami',
    terms_acceptance_required_description: 'Pro pokračování je nutné souhlasit s podmínkami.',
    something_went_wrong: 'Něco se pokazilo.',
    access_denied: 'Přístup odepřen',
    application_access_denied: 'Nemáš oprávnění k přístupu k této aplikaci. Kontaktuj prosím svého administrátora pro pomoc.',
    feature_not_enabled: 'Nemáš oprávnění k přístupu k této funkci. Kontaktuj prosím svého administrátora pro pomoc.',
};
export default Object.freeze(error);
